import { motion } from "framer-motion";

const tiles = [
  {
    id: "gallery-crocheting",
    img: "https://images.unsplash.com/photo-1519412849983-957822373d02?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwxfHxwZXJzb24lMjBjcm9jaGV0aW5nfGVufDB8fHx8MTc5MTc1NzI0M3ww&ixlib=rb-4.1.0&q=85",
    alt: "Hands crocheting a cozy piece",
    caption: "in the making",
    span: "md:col-span-2 md:row-span-2",
    height: "h-72 md:h-full",
  },
  {
    id: "gallery-yarn-basket",
    img: "https://images.unsplash.com/photo-1651341835779-5bbe6b035ba8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwxfHx5YXJuJTIwYmFza2V0fGVufDB8fHx8MTc5MTc1NzI0M3ww&ixlib=rb-4.1.0&q=85",
    alt: "Balls of yarn in a cozy basket",
    caption: "the yarn stash",
    span: "md:row-span-2",
    height: "h-72 md:h-full",
  },
  {
    id: "gallery-hooks",
    img: "https://images.unsplash.com/photo-1620633437938-be73c35eb77e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwyfHxjcm9jaGV0JTIwaG9va3N8ZW58MHx8fHwxNzkxNzU3MjQzfDA&ixlib=rb-4.1.0&q=85",
    alt: "Crochet hooks and stitch markers",
    caption: "tools of the trade",
    span: "",
    height: "h-56 md:h-64",
  },
  {
    id: "gallery-texture",
    img: "https://images.unsplash.com/photo-1615705592748-029c989e6d5c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwyfHxjcm9jaGV0JTIweWFybiUyMHRleHR1cmV8ZW58MHx8fHwxNzkxNzU3MjQzfDA&ixlib=rb-4.1.0&q=85",
    alt: "Soft crochet textile texture",
    caption: "stitch by stitch",
    span: "",
    height: "h-56 md:h-64",
  },
];

const Gallery = () => (
  <section id="inspiration" className="py-28 sm:py-36 bg-[#E8EAE3]/60" data-testid="inspiration-section">
    <div className="max-w-6xl mx-auto px-6">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        className="mb-16 flex flex-wrap items-end justify-between gap-6"
      >
        <div>
          <p className="font-hand text-2xl text-[#A67C52] -rotate-2 mb-2">crafty corner</p>
          <h2 className="font-heading font-medium tracking-tight text-3xl sm:text-4xl text-[#2C402B]">
            A little yarn-spiration
          </h2>
        </div>
        <p className="text-[#576956] max-w-sm text-sm sm:text-base leading-relaxed">
          Cozy stitches, well-loved hooks and baskets full of color — the
          everyday magic behind every Crochet Els piece.
        </p>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:grid-flow-dense md:[grid-template-rows:repeat(2,16rem)]" data-testid="gallery-grid">
        {tiles.map((t, i) => (
          <motion.figure
            key={t.id}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.8, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
            className={`group relative overflow-hidden rounded-3xl border border-[#D3D7CF] shadow-[0_8px_30px_rgba(44,64,43,0.08)] ${t.span} ${t.height}`}
            data-testid={`${t.id}-tile`}
          >
            <img
              src={t.img}
              alt={t.alt}
              className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-110"
            />
            <figcaption className="absolute bottom-4 left-4 bg-[#F9F6F0]/85 backdrop-blur-md rounded-full px-4 py-1.5 font-hand text-xl text-[#2C402B] -rotate-2 opacity-0 translate-y-2 transition-[opacity,transform] duration-500 group-hover:opacity-100 group-hover:translate-y-0">
              {t.caption}
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </div>
  </section>
);

export default Gallery;
